import { Component } from '@angular/core';
import { BaseService } from 'src/app/module_services/base.service';

@Component({
  selector: 'app-page-404',
  templateUrl: './page-404.component.html',
  styleUrls: ['./page-404.component.scss']
})
export class Page404Component {

  constructor(
    private _base: BaseService
  ) { }


  goToLogin() {
    this._base.redirectTo('/login')
  }
}
